import api from "./Api";

class PagarService {
  GetPagar(payload) {
    return api.get("/v1/pagar/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPagar(payload) {
    return api.post("/v1/pagar/", payload).then((response) => {
      return response.data;
    });
  }

  PutPagar(payload) {
    return api.put("/v1/pagar/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePagar(payload) {
    return api.delete("/v1/pagar/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPagarOData(payload) {
    return api.get("/OData/Pagar" + payload).then((response) => {
      return response.data;
    });
  }

  Estornar(payload) {
    return api
      .get("/v1/Pagar/Estornar?guid_transacao=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PagarRegistros(payload) {
    return api.post("/v1/Pagar/PagarRegistros/", payload).then((response) => {
      return response.data;
    });
  }

  ReplicarRegistros(payload) {
    return api
      .post("/v1/Pagar/ReplicarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  RenegociarRegistros(payload) {
    return api
      .post("/v1/Pagar/RenegociarRegistros/", payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirRecibo(payload) {
    return api
      .post("/v1/Pagar/ImprimirRecibo/", payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/Pagar/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }
}

export default new PagarService();
